import React from 'react'

import { useFormatPrice } from 'src/lib/js/hooks/useFormatPrice'

type PriceProps = {
  value: number
  trailingZeros?: boolean
}

const FormattedPrice = ({ value, trailingZeros }: PriceProps) => {
  return <>{useFormatPrice(value, trailingZeros)}</>
}

export default FormattedPrice
